import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

export type SetupPaymentIntentResponse = string;
type Variables = {};

export const useSetupPaymentIntent = createMutation<
  SetupPaymentIntentResponse,
  Variables,
  AxiosError
>({
  mutationFn: async () =>
    client({
      url: 'v2/customers/me/setup-intent',
      method: 'POST',
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
